import { useRef, useEffect, useState } from 'react'
import RichText from 'components/common/richText'
import { clamp } from 'utils/numberUtils'
import InfoIcon from 'images/Info Button.svg'
import { InfoButton, InfoPopup, InfoArrow } from './infoPopup_styles'

const InfoPopupWidget = ({ data, altText = '' }) => {
  const [popupOffset, setPopupOffset] = useState(-18)
  const buttonRef = useRef()

  useEffect(() => {
    const onResize = () => {
      const buttonRect = buttonRef.current?.getBoundingClientRect()
      setPopupOffset(clamp(window.innerWidth - buttonRect.x - 324, -272, -18))
    }
    onResize()
    window.addEventListener('resize', onResize, false)

    return () => window.removeEventListener('resize', onResize)
  }, [])

  return (
    <InfoButton>
      <img src={InfoIcon} alt={altText} ref={buttonRef} />
      <InfoArrow viewBox='0 0 20 12' width='20'>
        <path d='M10,0 L20,12 L0,12 Z' />
      </InfoArrow>
      <InfoPopup offset={popupOffset}>
        <RichText data={data} />
      </InfoPopup>
    </InfoButton>
  )
}

export default InfoPopupWidget